<app-side-top-bar [navigationItems]="navigationItems">
  <main>
    <section class="subscription-data-section">
      <div class="billing-data-form">
        <div class="billing-data-form-header">
          <h2>{{ labelService.getLabel("Dati Fatturazione") }}</h2>
          <div class="header-buttons">
            @if (isEditing) {
              <app-button
                [icon]="'delete'"
                (click)="onCancelClick()"
              ></app-button>
            }
            <app-button
              [icon]="isEditing ? 'save' : 'edit'"
              (click)="isEditing ? onSaveClick() : onEditClick()"
            ></app-button>
          </div>
        </div>

        @if (isLoading) {
          <div class="loading-container">
            <app-loader [size]="'big'"></app-loader>
          </div>
        }

        @if (!isLoading) {
          <form [formGroup]="form">
            <!-- Dati Identificativi Section -->
            <section class="form-section">
              <div class="section-header">
                <h3>Dati Identificativi</h3>
                <span class="info-message">
                  {{
                    labelService.getLabel(
                      "P.IVA e Codice Fiscale possono essere inseriti una sola volta"
                    )
                  }}
                </span>
              </div>
              <div class="form-row">
                <mat-form-field>
                  <mat-label>Partita IVA</mat-label>
                  <input
                    matInput
                    formControlName="vat_number"
                    [readonly]="!isEditing || doctorFiscalProfile.vat_number"
                    placeholder="Es. IT01234567890"
                    maxlength="13"
                  />
                </mat-form-field>
                <mat-form-field>
                  <mat-label>Codice Fiscale</mat-label>
                  <input
                    matInput
                    formControlName="fiscal_code"
                    [readonly]="!isEditing || doctorFiscalProfile.fiscal_code"
                    maxlength="16"
                  />
                </mat-form-field>
                <div class="sts-button-container">
                  <app-button
                    [text]="
                      stsProfileConfigured
                        ? 'Modifica credenziali STS'
                        : 'Configura credenziali STS'
                    "
                    (click)="onConfigureStsProfileClick()"
                  ></app-button>
                </div>
              </div>
            </section>
            <!-- Dati Generali Section -->
            <section class="form-section">
              <div class="section-header">
                <h3>Dati Generali</h3>
              </div>
              <div class="form-row">
                <mat-form-field>
                  <mat-label>Nome</mat-label>
                  <input
                    matInput
                    formControlName="first_name"
                    [readonly]="!isEditing"
                  />
                </mat-form-field>
                <mat-form-field>
                  <mat-label>Cognome</mat-label>
                  <input
                    matInput
                    formControlName="last_name"
                    [readonly]="!isEditing"
                  />
                </mat-form-field>
                <mat-form-field>
                  <mat-label>Specializzazione</mat-label>
                  <input matInput formControlName="specializzazione" />
                </mat-form-field>
              </div>
              <div class="form-row">
                <mat-form-field>
                  <mat-label>PEC</mat-label>
                  <input
                    matInput
                    formControlName="certified_email"
                    [readonly]="!isEditing"
                  />
                </mat-form-field>
                <mat-form-field>
                  <mat-label>Codice Destinatario</mat-label>
                  <input
                    matInput
                    formControlName="codice_univoco"
                    [readonly]="!isEditing"
                    placeholder="Es. ABCD123"
                  />
                </mat-form-field>
                <mat-form-field>
                  <mat-label>Regime Fiscale</mat-label>
                  <mat-select
                    formControlName="regime_fiscale"
                    [disabled]="!isEditing"
                  >
                    @for (option of regimeFiscaleOptions; track option) {
                      <mat-option [value]="option">
                        {{ option }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            </section>
            <!-- Dati Bancari Section -->
            <section class="form-section">
              <div class="section-header">
                <h3>Dati Bancari</h3>
              </div>
              <div class="form-row">
                <mat-form-field>
                  <mat-label>Nome Banca</mat-label>
                  <input
                    matInput
                    formControlName="bank_name"
                    [readonly]="!isEditing"
                  />
                </mat-form-field>
                <mat-form-field>
                  <mat-label>IBAN</mat-label>
                  <input
                    matInput
                    formControlName="iban"
                    [readonly]="!isEditing"
                  />
                </mat-form-field>
                <div class="empty-field"></div>
              </div>
              <div class="form-row">
                <mat-form-field>
                  <mat-label>Nome Banca 2</mat-label>
                  <input
                    matInput
                    formControlName="bank_name_2"
                    [readonly]="!isEditing"
                  />
                </mat-form-field>
                <mat-form-field>
                  <mat-label>IBAN 2</mat-label>
                  <input
                    matInput
                    formControlName="iban_2"
                    [readonly]="!isEditing"
                  />
                </mat-form-field>
                <div class="empty-field"></div>
              </div>
            </section>
            <!-- Indirizzo Section -->
            <section class="form-section">
              <div class="section-header">
                <h3>Indirizzo</h3>
              </div>
              <div class="form-row">
                <mat-form-field>
                  <mat-label>Indirizzo Fiscale</mat-label>
                  <input
                    matInput
                    formControlName="fiscal_address"
                    [readonly]="!isEditing"
                  />
                </mat-form-field>
                <mat-form-field>
                  <mat-label>Numero Civico</mat-label>
                  <input
                    matInput
                    formControlName="fiscal_street_number"
                    [readonly]="!isEditing"
                  />
                </mat-form-field>
              </div>
              <div class="form-row">
                <mat-form-field>
                  <mat-label>Città</mat-label>
                  <input
                    matInput
                    formControlName="fiscal_city"
                    [readonly]="!isEditing"
                  />
                </mat-form-field>
                <mat-form-field>
                  <mat-label>Provincia</mat-label>
                  <input
                    matInput
                    formControlName="fiscal_province"
                    [readonly]="!isEditing"
                    maxlength="2"
                    placeholder="Es. MI"
                  />
                </mat-form-field>
                <mat-form-field>
                  <mat-label>CAP</mat-label>
                  <input
                    matInput
                    formControlName="fiscal_zip_code"
                    [readonly]="!isEditing"
                    placeholder="Es. 20121"
                  />
                </mat-form-field>
              </div>
            </section>
          </form>
        }
      </div>
    </section>
  </main>
</app-side-top-bar>

@if (showConfirmationPanelForBusiness && businessDataToBeSaved) {
  <app-confirmation-panel-for-business
    [businessData]="businessDataToBeSaved!"
    (confirm)="onConfirmBusinessChanges()"
    (cancel)="onCancelBusinessChanges()"
  ></app-confirmation-panel-for-business>
}

@if (isEditingStsProfile) {
  <app-sts-credentials-panel
    [form]="stsForm"
    [mode]="stsProfileConfigured ? 'edit' : 'create'"
    [showStsPassword]="showStsPassword"
    [showStsPin]="showStsPin"
    [isSaving]="isSavingStsProfile"
    [stsUsername]="stsUsername"
    (togglePasswordVisibility)="toggleStsPasswordVisibility()"
    (togglePinVisibility)="toggleStsPinVisibility()"
    (close)="onCancelStsProfileClick()"
    (save)="onSaveStsProfileClick()"
  ></app-sts-credentials-panel>
}
